import React from 'react';
import { MoreVertical, Trash2 } from 'lucide-react';
import { Dropdown, DropdownItem } from 'shared-portal-components-v2';

import type { ExternalUser } from '@/types/external-users.types';

import ExternalUserStatusBadge from './ExternalUserStatusBadge';
import { getCreatedByLabel } from './externalUsersLabels';

interface ExternalUsersDesktopRowProps {
  user: ExternalUser;
  onDeleteRequest: (user: ExternalUser) => void;
}

function ExternalUsersDesktopRow({
  user,
  onDeleteRequest,
}: ExternalUsersDesktopRowProps): React.ReactElement {
  return (
    <div
      className="hidden md:grid grid-cols-16 items-center gap-3 border-b border-border px-4 py-3 text-sm text-foreground last:border-b-0"
      data-testid={`external-user-row-${user.id}`}
    >
      <div className="col-span-3 truncate font-medium" title={user.name}>
        {user.name}
      </div>
      <div className="col-span-3 truncate text-muted-foreground" title={user.email}>
        {user.email}
      </div>
      <div className="col-span-2 truncate text-muted-foreground" title={user.phone}>
        {user.phone}
      </div>
      <div className="col-span-2 truncate text-muted-foreground" title={user.deptOrg}>
        {user.deptOrg}
      </div>
      <div className="col-span-2 overflow-hidden whitespace-nowrap">
        <ExternalUserStatusBadge status={user.status} />
      </div>
      <div
        className="col-span-2 truncate text-muted-foreground"
        title={getCreatedByLabel(user.createdByAccount)}
      >
        {getCreatedByLabel(user.createdByAccount)}
      </div>
      <div className="col-span-1 text-muted-foreground">{user.sixCount}</div>
      <div className="col-span-1 flex justify-end">
        <Dropdown
          align="end"
          trigger={
            <button
              type="button"
              className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
              aria-label={`Actions for ${user.name}`}
            >
              <MoreVertical className="h-4 w-4" />
            </button>
          }
        >
          <DropdownItem
            onSelect={() => {
              onDeleteRequest(user);
            }}
          >
            <span className="flex items-center gap-2 text-destructive">
              <Trash2 className="h-4 w-4" />
              Delete
            </span>
          </DropdownItem>
        </Dropdown>
      </div>
    </div>
  );
}

export default ExternalUsersDesktopRow;
